export const indWVsIreWLeaderboardData = [
  {
    _id: '63f2f70248811c001df891dc',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '6218ea7f409340001d7e8ab7',
    firstname: 'shivram',
    lastname: 'madurkar',
    matchTeamId: '63f2f6d048811c001df891db',
    score: 0,
    username: 'Shivshakti11',
    answers: []
  },
  {
    _id: '63f327d948811c001df891f6',
    winning: 0,
    rank: 1,
    tenant: 'gamio',
    userId: '5fd32b93eaf661ea51eae8af',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    matchTeamId: '63f3278248811c001df891f5',
    score: 0,
    username: 'RajasthanRoyals',
    answers: []
  }
];
export const kolVsLsgLeaderboardData = [
  {
    _id: '6284c8a684ba3b001dc012aa',
    winning: 11100,
    rank: 1,
    tenant: 'gamio',
    userId: '61f785a5264ca9001fd737c1',
    verifiedScore: 30,
    firstname: 'Mohit',
    lastname: 'Saini',
    matchTeamId: '6284b0f784ba3b001dc00f39',
    score: 30,
    username: 'Sumit9258',
    answers: [
      {
        _id: '6284b0f584ba3b001dc00f2f',
        createdOn: '2022-05-18T08:40:21.057Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf939',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '61f785a5264ca9001fd737c1'
      },
      {
        _id: '6284b0f584ba3b001dc00f30',
        createdOn: '2022-05-18T08:40:21.059Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93a',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '61f785a5264ca9001fd737c1'
      },
      {
        _id: '6284b0f584ba3b001dc00f31',
        createdOn: '2022-05-18T08:40:21.059Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '61f785a5264ca9001fd737c1'
      },
      {
        _id: '6284b0f584ba3b001dc00f32',
        createdOn: '2022-05-18T08:40:21.059Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93c',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '61f785a5264ca9001fd737c1'
      },
      {
        _id: '6284b0f584ba3b001dc00f33',
        createdOn: '2022-05-18T08:40:21.059Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93d',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '61f785a5264ca9001fd737c1'
      },
      {
        _id: '6284b0f584ba3b001dc00f34',
        createdOn: '2022-05-18T08:40:21.060Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93e',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '61f785a5264ca9001fd737c1'
      },
      {
        _id: '6284b0f584ba3b001dc00f35',
        createdOn: '2022-05-18T08:40:21.060Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93f',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '61f785a5264ca9001fd737c1'
      },
      {
        _id: '6284b0f584ba3b001dc00f36',
        createdOn: '2022-05-18T08:40:21.060Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf940',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '61f785a5264ca9001fd737c1'
      },
      {
        _id: '6284b0f584ba3b001dc00f37',
        createdOn: '2022-05-18T08:40:21.060Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf941',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '61f785a5264ca9001fd737c1'
      },
      {
        _id: '6284b0f584ba3b001dc00f38',
        createdOn: '2022-05-18T08:40:21.061Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf942',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '61f785a5264ca9001fd737c1'
      }
    ]
  },
  {
    _id: '6284d3d884ba3b001dc01437',
    winning: 0,
    rank: 2,
    tenant: 'gamio',
    userId: '6127945762b5e00011ac1740',
    verifiedScore: 15,
    firstname: 'ALWAYS',
    lastname: 'WINNER',
    matchTeamId: '6284d3d484ba3b001dc01436',
    score: 15,
    username: 'indiafantasy26',
    answers: [
      {
        _id: '6284d3d384ba3b001dc0142c',
        createdOn: '2022-05-18T11:09:07.582Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf939',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '6127945762b5e00011ac1740'
      },
      {
        _id: '6284d3d384ba3b001dc0142d',
        createdOn: '2022-05-18T11:09:07.582Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93a',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '6127945762b5e00011ac1740'
      },
      {
        _id: '6284d3d384ba3b001dc0142e',
        createdOn: '2022-05-18T11:09:07.583Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93b',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '6127945762b5e00011ac1740'
      },
      {
        _id: '6284d3d384ba3b001dc0142f',
        createdOn: '2022-05-18T11:09:07.583Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93c',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '6127945762b5e00011ac1740'
      },
      {
        _id: '6284d3d384ba3b001dc01430',
        createdOn: '2022-05-18T11:09:07.583Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93d',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '6127945762b5e00011ac1740'
      },
      {
        _id: '6284d3d384ba3b001dc01431',
        createdOn: '2022-05-18T11:09:07.583Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93e',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '6127945762b5e00011ac1740'
      },
      {
        _id: '6284d3d384ba3b001dc01432',
        createdOn: '2022-05-18T11:09:07.584Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93f',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '6127945762b5e00011ac1740'
      },
      {
        _id: '6284d3d384ba3b001dc01433',
        createdOn: '2022-05-18T11:09:07.584Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf940',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '6127945762b5e00011ac1740'
      },
      {
        _id: '6284d3d384ba3b001dc01434',
        createdOn: '2022-05-18T11:09:07.584Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf941',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '6127945762b5e00011ac1740'
      },
      {
        _id: '6284d3d384ba3b001dc01435',
        createdOn: '2022-05-18T11:09:07.584Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf942',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '6127945762b5e00011ac1740'
      }
    ]
  },
  {
    _id: '6284d55784ba3b001dc014ba',
    winning: 0,
    rank: 3,
    tenant: 'gamio',
    userId: '5fd32b93eaf661ea51eae8af',
    verifiedScore: -5,
    firstname: 'Rajasthan',
    lastname: 'Royals',
    matchTeamId: '6284d55184ba3b001dc014b9',
    score: -5,
    username: 'RajasthanRoyals',
    answers: [
      {
        _id: '6284d55184ba3b001dc014af',
        createdOn: '2022-05-18T11:15:29.014Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf939',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '6284d55184ba3b001dc014b0',
        createdOn: '2022-05-18T11:15:29.015Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93a',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '6284d55184ba3b001dc014b1',
        createdOn: '2022-05-18T11:15:29.015Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93b',
        answer: true,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '6284d55184ba3b001dc014b2',
        createdOn: '2022-05-18T11:15:29.015Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93c',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '6284d55184ba3b001dc014b3',
        createdOn: '2022-05-18T11:15:29.016Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93d',
        answer: true,
        isPowerUp: true,
        point: 10,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '6284d55184ba3b001dc014b4',
        createdOn: '2022-05-18T11:15:29.017Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93e',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '6284d55184ba3b001dc014b5',
        createdOn: '2022-05-18T11:15:29.017Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf93f',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '6284d55184ba3b001dc014b6',
        createdOn: '2022-05-18T11:15:29.017Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf940',
        answer: true,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '6284d55184ba3b001dc014b7',
        createdOn: '2022-05-18T11:15:29.018Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf941',
        answer: true,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '6284d55184ba3b001dc014b8',
        createdOn: '2022-05-18T11:15:29.018Z',
        deletedOn: null,
        matchId: '628240bd6d0713b9cf82d75c',
        questionId: '62848af9f19d86001d6bf942',
        answer: true,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      }
    ]
  }
];

export const punVsDcLeaderBoardData = [
  {
    _id: '62824f3c84ba3b001dbfed15',
    winning: 10800,
    rank: 1,
    tenant: 'gamio',
    userId: '607016a9842639055e8aa01e',
    verifiedScore: 25,
    firstname: 'Mumbai',
    lastname: 'Indians',
    matchTeamId: '628244d892265b0020539796',
    score: 25,
    username: 'MUMBAIINDIAN1207',
    answers: [
      {
        _id: '628244d892265b002053978c',
        createdOn: '2022-05-16T12:34:32.180Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978d',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978e',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978f',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539790',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539791',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539792',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539793',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539794',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539795',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      }
    ]
  },
  {
    _id: '62824f5f84ba3b001dbfed18',
    winning: 0,
    rank: 2,
    tenant: 'gamio',
    userId: '5fd32b93eaf661ea51eae8af',
    verifiedScore: 5,
    firstname: 'Rajasthan',
    lastname: 'Royals',
    matchTeamId: '628242eb92265b002053978b',
    score: 5,
    username: 'RajasthanRoyals',
    answers: [
      {
        _id: '628242eb92265b0020539781',
        createdOn: '2022-05-16T12:26:19.873Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539782',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539783',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539784',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539785',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539786',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539787',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539788',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539789',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b002053978a',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      }
    ]
  }
];

export const nzVsPakYesNoLeaderBoardData = [
  {
    _id: '63c11d9c9dfb9f001cf6ff27',
    winning: 10800,
    rank: 1,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4929',
    firstname: 'Anmol',
    lastname: 'Kapoor',
    teamNumber: 7,
    matchTeamId: '63c054969dfb9f001cf67f9a',
    captainId: '63be86fe0901e17d0f433096',
    viceCaptainId: '63be86fe0901e17d0f43309c',
    score: 25,
    verifiedScore: 25,
    username: 'rakeshsarkar11',
    answers: [
      {
        _id: '628244d892265b002053978c',
        createdOn: '2022-05-16T12:34:32.180Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978d',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978e',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978f',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539790',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539791',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539792',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539793',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539794',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539795',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      }
    ]
  },
  {
    _id: '63c1000a9dfb9f001cf6d237',
    winning: 10800,
    rank: 2,
    tenant: 'gamio',
    userId: '623d499851b136001ebd4957',
    firstname: 'Ulmuk',
    lastname: 'Chawla',
    teamNumber: 4,
    matchTeamId: '63c054969dfb9f001cf68191',
    captainId: '63be86fe0901e17d0f43309c',
    viceCaptainId: '63be86fe0901e17d0f433096',
    score: 15,
    verifiedScore: 15,
    username: 'ramvilash37',
    answers: [
      {
        _id: '628242eb92265b0020539781',
        createdOn: '2022-05-16T12:26:19.873Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539782',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539783',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539784',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539785',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539786',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539787',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539788',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539789',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b002053978a',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      }
    ]
  }
];

export const indVsZimYesNoLeaderBoardData = [
  {
    _id: '63003754405a94001d2083a8',
    winning: 500000,
    rank: 1,
    tenant: 'gamio',
    userId: '62ef5738c52f1a001eb60c44',
    teamNumber: 2,
    matchTeamId: '6300370ad344d0001f309131',
    captainId: '62fdf27a1f7aacc4e353317f',
    viceCaptainId: '62fdf27a1f7aacc4e35331bf',
    score: 25,
    verifiedScore: 25,
    username: '62ef5738c52f1a001eb60c43',
    answers: [
      {
        _id: '628244d892265b002053978c',
        createdOn: '2022-05-16T12:34:32.180Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978d',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978e',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978f',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539790',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539791',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539792',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539793',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539794',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539795',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      }
    ]
  },
  {
    _id: '63008795db79c0002171b963',
    winning: 115000,
    rank: 2,
    tenant: 'gamio',
    userId: '623d499851b136001ebd49d1',
    firstname: 'Kripa',
    lastname: '_',
    teamNumber: 8,
    matchTeamId: '62ffc942db79c00021715ab3',
    captainId: '62fdf27a1f7aacc4e353317f',
    viceCaptainId: '62fdf27a1f7aacc4e35331bf',
    score: 5,
    verifiedScore: 5,
    username: 'gutam4',
    answers: [
      {
        _id: '628242eb92265b0020539781',
        createdOn: '2022-05-16T12:26:19.873Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539782',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539783',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539784',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539785',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539786',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539787',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539788',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539789',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b002053978a',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      }
    ]
  }
];

export const slVsAfgYesNoLeaderBoardData = [
  {
    _id: '62824f3c84ba3b001dbfed15',
    winning: 400000,
    rank: 1,
    tenant: 'gamio',
    userId: '607016a9842639055e8aa01e',
    verifiedScore: 25,
    firstname: 'Mumbai',
    lastname: 'Indians',
    matchTeamId: '628244d892265b0020539796',
    score: 25,
    username: 'MUMBAIINDIAN1207',
    answers: [
      {
        _id: '628244d892265b002053978c',
        createdOn: '2022-05-16T12:34:32.180Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978d',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978e',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978f',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539790',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539791',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539792',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539793',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539794',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539795',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      }
    ]
  },
  {
    _id: '62824f5f84ba3b001dbfed18',
    winning: 200000,
    rank: 2,
    tenant: 'gamio',
    userId: '5fd32b93eaf661ea51eae8af',
    verifiedScore: 5,
    firstname: 'Rajasthan',
    lastname: 'Royals',
    matchTeamId: '628242eb92265b002053978b',
    score: 5,
    username: 'RajasthanRoyals',
    answers: [
      {
        _id: '628242eb92265b0020539781',
        createdOn: '2022-05-16T12:26:19.873Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539782',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539783',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539784',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539785',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539786',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539787',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539788',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539789',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b002053978a',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      }
    ]
  }
];

export const indVsSaYesNoLeaderBoardData = [
  {
    _id: '63390fb329a44d001d391c97',
    winning: 30000,
    rank: 1,
    tenant: 'gamio',
    userId: '63344b2c69b991001fa16e88',
    teamNumber: 6,
    matchTeamId: '63390b0d29a44d001d391c5b',
    captainId: '63345055258445b807483a35',
    viceCaptainId: '63345055258445b807483a4f',
    score: 25,
    verifiedScore: 25,
    username: '63344b2c69b991001fa16e87',
    answers: [
      {
        _id: '628244d892265b002053978c',
        createdOn: '2022-05-16T12:34:32.180Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978d',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978e',
        createdOn: '2022-05-16T12:34:32.181Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b002053978f',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539790',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539791',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539792',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539793',
        createdOn: '2022-05-16T12:34:32.182Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539794',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: false,
        isPowerUp: true,
        point: 10,
        userId: '607016a9842639055e8aa01e'
      },
      {
        _id: '628244d892265b0020539795',
        createdOn: '2022-05-16T12:34:32.183Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '607016a9842639055e8aa01e'
      }
    ]
  },
  {
    _id: '6339873d2dcd02001dbafcbd',
    winning: 15000,
    rank: 2,
    tenant: 'gamio',
    userId: '6184ed82351c65001fa3381a',
    firstname: 'Rashid',
    lastname: 'Siddiqui',
    teamNumber: 1,
    matchTeamId: '633987362dcd02001dbafcb9',
    captainId: '63345055258445b807483a66',
    viceCaptainId: '63345055258445b807483a32',
    score: 5,
    verifiedScore: 5,
    username: 'Rashidali',
    answers: [
      {
        _id: '628242eb92265b0020539781',
        createdOn: '2022-05-16T12:26:19.873Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539777',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539782',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539778',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539783',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539779',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539784',
        createdOn: '2022-05-16T12:26:19.874Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977a',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539785',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977b',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539786',
        createdOn: '2022-05-16T12:26:19.875Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977c',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539787',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977d',
        answer: false,
        isPowerUp: false,
        point: 5,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539788',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977e',
        answer: false,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b0020539789',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b002053977f',
        answer: true,
        isPowerUp: false,
        point: 0,
        userId: '5fd32b93eaf661ea51eae8af'
      },
      {
        _id: '628242eb92265b002053978a',
        createdOn: '2022-05-16T12:26:19.876Z',
        deletedOn: null,
        matchId: '627fbf7d6d0713b9cf388229',
        questionId: '628241eb92265b0020539780',
        answer: false,
        isPowerUp: true,
        point: -10,
        userId: '5fd32b93eaf661ea51eae8af'
      }
    ]
  }
];
